import { useEffect } from 'react'
import Vivus from 'vivus'

type Props = {
  wrapper_id: string
  img_src: string
  className?: string
}

const AnimatedSvg = ({ wrapper_id, img_src, className }: Props) => {
  // the vivus object must the initialized after the component has been mounted
  useEffect(() => {
    new Vivus(wrapper_id, {
      duration: 100,
      file: img_src,
      animTimingFunctino: Vivus.EASE_OUT,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div id={wrapper_id} className={className}></div>
}

export default AnimatedSvg
